export const ajaxFunc = () => {
  /**
   * 非同期でフェア情報を取得
   */
  {
    const $buttonArr = [...document.querySelectorAll('.js-fair-button')];
    const $content = document.querySelector('.js-fair-content');
    const dateArr = [];

    const getData = () => {
      const params = new URLSearchParams(),
        options = { body: params, method: 'post' };

      params.append('action', 'get_fair_data');
      params.append('dateArr', dateArr);

      fetch(`${wp.home_url}/wp-admin/admin-ajax.php`, options)
        .then(response => response.json())
        .then(data => insertAccordion(data))
        .catch(error => console.error('通信に失敗しました', error));
    };

    const insertAccordion = data => {
      console.dir(data);
      let html = '';

      for (const [date, arr] of Object.entries(data)) {
        html += `<section class="p-fair-accordion${arr.length > 1 ? ' js-accordion' : ''}">
          <h3 class="p-fair-accordion__title">${date}<span>開催のフェア</span></h3>
          ${insertItem(arr)}
          ${arr.length > 1 ? '<button class="p-fair-accordion__toggle js-accordion__toggle">同じ日開催のその他フェアを見る</button>' : ''}
        </section>`;
      }

      $content.innerHTML = html;
      registerAccordion();
    };

    const insertItem = arr => {
      let html = '';

      arr.forEach((obj, i) => {
        if (i == 1) html += `<div class="p-fair-accordion__content js-accordion__content">`;

        html += `<article class="p-fair-item">
          <div class="p-fair-item__contents">
            ${obj.date ? `<p class="p-fair-item__date">
              <span class="date">${obj.date}</span>
              <span class="week">（${obj.week}）</span>
            </p><!-- /.p-fair-item__date -->` : ''}

            ${obj.time_list ? `<p class="p-fair-item__time">${obj.time_list}</p>` : ''}
            <h4 class="p-fair-item__title">${obj.title}</h4>
            ${obj.fair_tags ? `<p class="p-fair-item__tags">${obj.fair_tags}</p>` : ''}

            <div class="p-fair-item__thumbnail">
              <img src="${obj.thumbnail_url}" alt="${obj.thumbnail_alt}">
            </div><!-- /.p-fair-item__thumbnail -->

            ${obj.description ? `<p class="p-fair-item__text">${obj.description}</p>` : ''}

            <div class="p-fair-item__button">
              <a href="${obj.permalink}" class="c-button-underline">MORE</a>
            </div><!-- /.p-fair-item__button -->
          </div><!-- /.p-fair-item__contents -->
        </article><!-- /.p-fair-item -->`;

        if (arr.length > 1 && arr.length - 1 == i) html += `</div>`;
      });

      return html;
    };

    const registerAccordion = () => {
      const $accordionArr = [...document.querySelectorAll('.js-accordion')];

      $accordionArr.forEach($accordion => {
        const $toggle = $accordion.querySelector('.js-accordion__toggle');
        const $content = $accordion.querySelector('.js-accordion__content');

        $toggle.addEventListener('click', () => {
          $accordion.classList.toggle('is--open');
          $content.style.height = $accordion.classList.contains('is--open') ? `${$content.scrollHeight}px` : null;
        });
      });
    };

    $buttonArr.forEach($button => {
      $button.addEventListener('click', () => {
        const date = $button.dataset.date;

        if ($button.classList.contains('is--active')) {
          dateArr.splice(dateArr.indexOf(date), 1);
        } else {
          dateArr.push(date);
        }

        $button.classList.toggle('is--active');
        getData();
      });
    });
  }
};
